import { Pagination } from '@mui/material';
import { ChangeEvent } from 'react';
import { AppealsFromSiteI, appealsFromAppApiI } from '../../interfaces/appealsAPI';

interface paginationPropsI {
  response: appealsFromAppApiI | AppealsFromSiteI | undefined;
  currentPage: number;
  handleChangePage: (event: ChangeEvent<unknown>, value: number) => void;
}

export const paginationAppeals = ({                                 // пагинация страниц
  response,
  currentPage,       
  handleChangePage,
}: paginationPropsI) => {
  if (response && response.quantityToPages > 1) {
    return (
      <Pagination
        color="primary"
        count={response.quantityToPages}
        page={currentPage}
        onChange={handleChangePage}
        showFirstButton
        showLastButton
      />
    );
  } else return null;
};
